/**
 * Global Application Configuration
 * 
 * This file exports the global configuration for the application.
 */

export const config = {
  DR_HERANCA_API: process.env.REACT_APP_DR_HERANCA_API || '',
  // Bump this value when a deploy requires forcing browser cache refresh.
  FRONTEND_CACHE_VERSION: process.env.REACT_APP_FRONTEND_CACHE_VERSION || '2026-05-05',
};

